import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const namespace = 'handler-list';
export const keyPrefix = 'handler_list';

export const useHandlerListTranslation = (): UseTranslationResponse<
  typeof namespace,
  typeof keyPrefix
> => useTranslation(namespace, { keyPrefix });

export const ruRu = {
  [namespace]: {
    [keyPrefix]: {
      title: 'Сценарии',
      actions: {
        add: 'Добавить',
      },
      columns: {
        description: 'Описание',
        handler_id: 'ID сценария',
        owner_department: 'Подразделение владелец',
      },
    },
  },
};

export const en = {
  [namespace]: {
    [keyPrefix]: {
      title: 'Policies',
      actions: {
        add: 'Add',
      },
      columns: {
        description: 'Description',
        handler_id: 'Policy ID',
        owner_department: 'Owner department',
      },
    },
  },
};

export const esEs = {
  [namespace]: {
    [keyPrefix]: {
      title: 'Escenarios',
      actions: {
        add: 'Añadir',
      },
      columns: {
        description: 'Descripción',
        handler_id: 'ID del escenario',
        owner_department: 'Departamento propietario',
      },
    },
  },
};

export const ptBr = {
  [namespace]: {
    [keyPrefix]: {
      title: 'Cenários',
      actions: {
        add: 'Adicionar',
      },
      columns: {
        description: 'Descrição',
        handler_id: 'ID do cenário',
        owner_department: 'Departamento proprietário',
      },
    },
  },
};

export const HandlerListI18n = {
  ruRu,
  en,
  esEs,
  ptBr,
};
